import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseCurriculumUnitKnowledgeMaps } from '@/api/responses/curriculumUnitKnowledgeMaps'

export namespace CurriculumUnitKnowledgeMapsApi {
  /**
   * 知識マップ単元情報取得
   *
   * @param systemChartId 知識マップID
   * @param userId 対象ユーザID(未指定時は実行ユーザ)
   * @returns 知識マップ単元情報
   */
  export async function getCurriculumUnitKnowledgeMaps(
    systemChartId: number,
    userId?: number
  ): Promise<ApiResponseCurriculumUnitKnowledgeMaps> {
    const params = {}
    if (userId) {
      Object.assign(params, { userId: userId })
    }
    return await ApiBase.get(`/curriculumUnitKnowledgeMaps/${systemChartId}`, params)
  }
}
